import { createRouter, createWebHistory } from "vue-router";
/* Layouts */
const Dashboard = () => import('../layouts/Dashboard')
const BlacktelAuth = () => import('../layouts/AuthLayouts/BlacktelAuth')

/* Authentic View */
const SignIn = () => import('../views/AuthPages/Default/SignIn')
const SignUp = () => import('../views/AuthPages/Default/SignUp')
const Recover = () => import('../views/AuthPages/Default/RecoverPassword')

/* Extra Pages */
const Activity = () => import('../views/Pages/Activity')
const DashboardPage = () => import('../views/Pages/Dashboard')
const Messages = () => import('../views/Pages/Messages')
const Faxes = () => import('../views/Pages/Faxes')
const Calls = () => import('../views/Pages/Calls')
const Contacts = () => import('../views/Pages/Contacts')
const VirtualNumbers = () => import('../views/Pages/VirtualNumbers')
const Settings = () => import('../views/Pages/Settings')
const Search = () => import('../views/Pages/Search')
const Credits = () => import('../views/Pages/Credits')
const CallFullScreen = () => import('../views/Pages/CallFullScreen')

/* Activity Pages */
const Recent = () => import('../views/Activity/Recent')
const Call = () => import('../views/Activity/Call')
const Message = () => import('../views/Activity/Message')
const Fax = () => import('../views/Activity/Fax')
const Notification = () => import('../views/Activity/Notification')

const authChildRoutes = (prop, mode = false) => [
  {
    path: 'login/:mid?/:secureid?',
    name: prop + '.sign-in1',
    meta: { dark: mode, auth: false, title: 'Sign In' },
    component: SignIn
  },
  {
    path: 'sign-up',
    name: prop + '.sign-up1',
    meta: { dark: mode, auth: false, title: 'Sign Up' },
    component: SignUp
  },
  {
    path: 'recover-password',
    name: prop + '.recover1',
    meta: { dark: mode, auth: false, title: 'Recover' },
    component: Recover
  }
]

const dashboardPagesRoutes = (prop, mode = false) => [
  {
    path: '',
    name: prop + '.dashboard',
    meta: { dark: mode, auth: true, name: 'Dashboard Page', background: false, title: 'Dashboard', parent: 'root' },
    component: DashboardPage
  },
  {
    path: 'activity',
    name: prop + '.activity',
    meta: { dark: mode, auth: true, name: 'Acivity Page', background: true, title: 'Activity', parent: 'root' },
    component: Activity,
    children: [
      {
        path: '',
        name: 'activity.recent',
        meta: { dark: mode, auth: true, background: true, title: 'Activity', parent: 'activity' },
        component: Recent
      },
      {
        path: 'call',
        name: 'activity.call',
        meta: { dark: mode, auth: true, background: true, title: 'Activity', parent: 'activity' },
        component: Call
      },
      {
        path: 'message',
        name: 'activity.message',
        meta: { dark: mode, auth: true, background: true, title: 'Activity', parent: 'activity' },
        component: Message
      },
      {
        path: 'fax',
        name: 'activity.fax',
        meta: { dark: mode, auth: true, background: true, title: 'Activity', parent: 'activity' },
        component: Fax
      },
      {
        path: 'notification',
        name: 'activity.notification',
        meta: { dark: mode, auth: true, background: true, title: 'Activity', parent: 'activity' },
        component: Notification
      }
    ]
  },
  {
    path: 'messages/:id?',
    name: prop + '.messages',
    meta: { dark: mode, auth: true, name: 'Message Page', background: false, title: 'Messages', parent: 'root' },
    component: Messages
  },
  {
    path: 'faxes/:id?',
    name: prop + '.faxes',
    meta: { dark: mode, auth: true, name: 'Fax Page', background: false, title: 'Faxes', parent: 'root' },
    component: Faxes
  },
  {
    path: 'calls/:id?',
    name: prop + '.calls',
    meta: { dark: mode, auth: true, name: 'Call Page', background: false, title: 'Calls', parent: 'root' },
    component: Calls
  },
  {
    path: 'contacts/:id?',
    name: prop + '.contacts',
    meta: { dark: mode, auth: true, name: 'Contacts Page', background: false, title: 'Contacts', parent: 'root' },
    component: Contacts
  },
  {
    path: 'numbers/:id?',
    name: prop + '.numbers',
    meta: { dark: mode, auth: true, name: 'Virtual Numbers', background: false, title: 'Numbers', parent: 'root' },
    component: VirtualNumbers
  },
  {
    path: 'setting/:id?',
    name: prop + '.setting',
    meta: { dark: mode, auth: true, name: 'Setting', background: false, title: 'Settings', parent: 'root' },
    component: Settings
  },
  {
    path: 'search/:id?',
    name: prop + '.search',
    meta: { dark: mode, auth: true, name: 'Search', background: false, title: 'Search', parent: 'root' },
    component: Search
  },
  {
    path: 'credits/:id?',
    name: prop + '.credits',
    meta: { dark: mode, auth: true, name: 'Credits', background: false, title: 'Credits', parent: 'root' },
    component: Credits
  },
  {
    path: 'calls-fullscreen/:id?',
    name: prop + '.calls-fullscreen',
    meta: { dark: mode, auth: true, name: 'CallFullScreen', background: false, title: 'CallFullScreen', parent: 'root' },
    component: CallFullScreen
  }
]

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard,
    meta: { auth: true },
    children: dashboardPagesRoutes('dashboard')
  },
  {
    path: '/',
    name: 'blacktel',
    component: BlacktelAuth,
    meta: { auth: true },
    children: authChildRoutes('blacktel')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  try {
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
    if (nearestWithTitle) document.title = nearestWithTitle.meta.title
    const publicPages = ['blacktel.sign-in1', 'blacktel.sign-up1']
    const authRequired = !publicPages.includes(to.name)
    const loggedIn = localStorage.getItem('user')
    const secureId = localStorage.getItem('secureid')
    const mid = localStorage.getItem('mid')
    if (to.meta.auth && authRequired) {
      if (loggedIn == null || loggedIn === '' || mid === null || secureId == null) {
        return next('/login')
      }
    }
    if (from.name === null && to.name === 'blacktel') {
      return next('/dashboard')
    }
    next()
  }
  catch(err) {
    // Catch Block
  }
})

export default router
